import { render, staticRenderFns } from "./AssetOwnerDialog.vue?vue&type=template&id=b85b1e68&scoped=true&"
import script from "./AssetOwnerDialog.vue?vue&type=script&lang=js&"
export * from "./AssetOwnerDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssetOwnerDialog.vue?vue&type=style&index=0&id=b85b1e68&lang=scss&scoped=true&"
import style1 from "./AssetOwnerDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85b1e68",
  null
  
)

export default component.exports